/* Chubbytrend header interactions. Dawn remains responsible for core disclosure/search behavior. */
(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  const readCartCount = (root) => {
    const countText =
      root?.querySelector('.cart-count-bubble [aria-hidden="true"]')?.textContent ||
      root?.querySelector('.cart-count-bubble')?.textContent ||
      '0';

    return Number.parseInt(countText.match(/\d+/)?.[0] || '0', 10);
  };

  const initCartHeader = () => {
    const cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || cartLink.dataset.ctCartHeaderReady === 'true') return;

    const customCopy = cartLink.querySelector('.ct-header-action__copy');
    if (!customCopy) return;

    cartLink.dataset.ctCartHeaderReady = 'true';
    const templateHTML = cartLink.innerHTML;

    const updateCount = (count, sourceBubble = null) => {
      const currentLink = document.getElementById('cart-icon-bubble');
      if (!currentLink) return;

      const copyCount = currentLink.querySelector('.ct-header-action__cart-count');
      if (copyCount) copyCount.textContent = `(${count})`;

      currentLink.querySelector('.cart-count-bubble')?.remove();

      if (count > 0) {
        const bubble = sourceBubble?.cloneNode(true) || document.createElement('div');

        if (!sourceBubble) {
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} ${
            count === 1 ? 'item' : 'items'
          }</span>`;
        }

        currentLink.appendChild(bubble);
      }
    };

    const restoreCustomMarkup = (count, sourceBubble = null) => {
      const currentLink = document.getElementById('cart-icon-bubble');
      if (!currentLink) return false;

      if (!currentLink.querySelector('.ct-header-action__copy')) {
        currentLink.innerHTML = templateHTML;
      }

      updateCount(count, sourceBubble);
      return true;
    };

    const renderFromSection = (html) => {
      if (!html) return false;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const section = parsed.querySelector('.shopify-section') || parsed.body;
      const bubble = section.querySelector('.cart-count-bubble');

      return restoreCustomMarkup(readCartCount(section), bubble);
    };

    window.CTCartHeader = { renderFromSection, updateCount };

    new MutationObserver(() => {
      const currentLink = document.getElementById('cart-icon-bubble');
      if (!currentLink || currentLink.querySelector('.ct-header-action__copy')) return;

      const bubble = currentLink.querySelector('.cart-count-bubble');
      restoreCustomMarkup(readCartCount(currentLink), bubble);
    }).observe(cartLink, { childList: true });
  };

  const setMenuOpen = (menu, shouldOpen) => {
    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    details.open = shouldOpen;
    summary.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  };

  const closeSiblingMenus = (menu) => {
    const nav = menu.closest('.ct-nav');
    nav?.querySelectorAll('header-menu').forEach((candidate) => {
      if (candidate !== menu) setMenuOpen(candidate, false);
    });
  };

  const initHeaderNavigation = (root = document) => {
    root.querySelectorAll('.ct-nav').forEach((nav) => {
      if (nav.dataset.ctNavigationReady === 'true') return;
      nav.dataset.ctNavigationReady = 'true';

      nav.querySelectorAll('header-menu').forEach((menu) => {
        const details = menu.querySelector(':scope > details');
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;

        let closeTimer;
        const cancelClose = () => window.clearTimeout(closeTimer);
        const openMenu = () => {
          if (!desktopHover.matches) return;
          cancelClose();
          closeSiblingMenus(menu);
          setMenuOpen(menu, true);
        };
        const queueClose = () => {
          if (!desktopHover.matches) return;
          cancelClose();
          closeTimer = window.setTimeout(() => {
            if (!menu.contains(document.activeElement)) setMenuOpen(menu, false);
          }, 140);
        };

        menu.addEventListener('mouseenter', openMenu);
        menu.addEventListener('mouseleave', queueClose);
        menu.addEventListener('focusin', () => {
          cancelClose();
          closeSiblingMenus(menu);
        });
        menu.addEventListener('focusout', queueClose);

        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          if (details.open) closeSiblingMenus(menu);
        });

        menu.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          setMenuOpen(menu, false);
          summary.focus();
        });
      });
    });
  };

  const closeAllMenus = () => {
    document.querySelectorAll('.ct-nav header-menu').forEach((menu) => setMenuOpen(menu, false));
  };

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderNavigation();
    initCartHeader();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initHeaderNavigation(event.target);
    initCartHeader();
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ct-nav')) closeAllMenus();
  });
})();
